import React from 'react';
import uuid from 'uuid/v1';
import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty } from 'lodash';
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Pagination,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsIcon from '@mui/icons-material/Settings';
import ShareIcon from '@mui/icons-material/Share';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';
import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';

const RouteConfiguration = ({ createRouteConfiguration, handleRouteConfiguration, videoList }) => {
  const [openModal, setOpenModal] = React.useState(false);
  const [openModalButton, setOpenModalButton] = React.useState(false);
  const [name, setName] = React.useState('');
  const [buttonSelect, setButtonSelect] = React.useState({});
  const [videoSelect, setVideoSelect] = React.useState('');
  const [openModalFinalButton, setOpenModalFinalButton] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const itemsPerPage = 5;
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const ModeRouteOptions = [
    { value: 'foot-walking', name: 'Walking' },
    { value: 'driving-car', name: 'By car' }
  ];

  const isFormValid = () => {
    return (
      !isEmpty(createRouteConfiguration.buttonCreateRoute.name) &&
      !isEmpty(createRouteConfiguration.endPoints)
    );
  };

  const handleAddFinalPoints = () => {
    if (!createRouteConfiguration.endPoints || isEmpty(createRouteConfiguration.endPoints)) {
      const newConfig = {
        ...createRouteConfiguration,
        endPoints: [{ name, button: buttonSelect, videoId: videoSelect }]
      };
      handleRouteConfiguration(newConfig);
    } else if (!isEmpty(createRouteConfiguration.endPoints)) {
      const newFinalPoints = [
        ...createRouteConfiguration.endPoints,
        { name, button: buttonSelect, videoId: videoSelect }
      ];
      const newConfig = { ...createRouteConfiguration, endPoints: newFinalPoints };
      handleRouteConfiguration(newConfig);
    }
    setName('');
    setButtonSelect({});
    setVideoSelect('');
  };

  const handleIconCurrentLocationSelected = (elementIcon, library) => {
    let newConfig = {};
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      newConfig = {
        ...createRouteConfiguration,
        buttonCreateRoute: {
          ...createRouteConfiguration.buttonCreateRoute,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      };
    } else if (library === LIBRARY_ICON_TYPES.SVG) {
      newConfig = {
        ...createRouteConfiguration,
        buttonCreateRoute: {
          ...createRouteConfiguration.buttonCreateRoute,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      };
    } else {
      newConfig = {
        ...createRouteConfiguration,
        buttonCreateRoute: {
          ...createRouteConfiguration.buttonCreateRoute,
          libraryIcon: library
        }
      };
    }
    handleRouteConfiguration(newConfig);
  };

  const handleIconSelect = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setButtonSelect({
        ...buttonSelect,
        iconFontawesome: elementIcon,
        libraryIcon: library,
        show: true
      });
    } else if (library === LIBRARY_ICON_TYPES.SVG) {
      setButtonSelect({
        ...buttonSelect,
        iconFontawesome: elementIcon.name,
        iconSvg: elementIcon.url,
        libraryIcon: library,
        cetegorySvg: elementIcon.category,
        show: true
      });
    } else {
      setButtonSelect({
        ...buttonSelect,
        libraryIcon: library,
        show: true
      });
    }
  };

  const handleDeleteUser = index => {
    const newConfig = {
      ...createRouteConfiguration,
      endPoints: createRouteConfiguration.endPoints.filter((_, i) => i !== index)
    };
    handleRouteConfiguration(newConfig);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const body = (
    <Box backgroundColor="white" width="95vw" height="95vh">
      <Box display="flex" height="10%" width="100%" alignItems="center" mr={5}>
        <Grid container direction="row" justifyContent="space-around" spacing={3}>
          <Grid item xs={10} sx={{ justifyContent: 'space-around', display: 'flex' }}>
            <Typography align="center" sx={{ color: 'black', fontFamily: 'Arial' }} variant="h6">
              Configuration of the route creation function
            </Typography>
          </Grid>
          <Grid item xs={2} sx={{ justifyContent: 'space-around', display: 'flex' }}>
            <Button
              color="success"
              variant="outlined"
              onClick={() => {
                if (isFormValid()) {
                  setOpenModal(false);
                } else {
                  Bert.alert('Please fill all the required fields.', 'warning');
                }
              }}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box height="90%" width="100%" ml={3} mr={3} justifyContent="center">
        <Box display="column" width="40%" gab={1}>
          <Box
            component="form"
            sx={{
              display: 'flex',
              mb: 2,
              width: '100%'
            }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="outlined-required"
              label="Enter a title for the coordinates button"
              size="small"
              focused
              value={createRouteConfiguration.buttonCreateRoute.name}
              onChange={event => {
                const newConfig = {
                  ...createRouteConfiguration,
                  buttonCreateRoute: {
                    ...createRouteConfiguration.buttonCreateRoute,
                    name: event.target.value
                  }
                };
                handleRouteConfiguration(newConfig);
              }}
              mb={2}
              fullWidth
            />
            <IconButton
              onClick={() => setOpenModalButton(true)}
              style={{
                color: '#2A3F90'
              }}
            >
              {!isEmpty(createRouteConfiguration.buttonCreateRoute.libraryIcon) ? (
                <>
                  {createRouteConfiguration.buttonCreateRoute.libraryIcon ===
                    LIBRARY_ICON_TYPES.FONTAWESOME && (
                    <FontAwesomeIcon
                      icon={createRouteConfiguration.buttonCreateRoute.iconFontawesome}
                    />
                  )}
                  {createRouteConfiguration.buttonCreateRoute.libraryIcon ===
                    LIBRARY_ICON_TYPES.SVG && (
                    <img
                      src={createRouteConfiguration.buttonCreateRoute.iconSvg}
                      alt={createRouteConfiguration.buttonCreateRoute.iconFontawesome}
                      style={{ marginRight: '5px', width: '20px', height: '20px' }}
                    />
                  )}
                </>
              ) : (
                <ShareIcon />
              )}
            </IconButton>
            <ShowListIconsFontawesome
              openModal={openModalButton}
              setOpenModal={setOpenModalButton}
              handleIconSelected={handleIconCurrentLocationSelected}
              selectedIcon={createRouteConfiguration.buttonCreateRoute.iconFontawesome}
              startLibrary={createRouteConfiguration.buttonCreateRoute.libraryIcon}
              svg={createRouteConfiguration.buttonCreateRoute.iconSvg}
              startCategorySvg={createRouteConfiguration.buttonCreateRoute.cetegorySvg}
            />
          </Box>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="demo-simple-select-label">
              Video of the points to avoid on the map
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={createRouteConfiguration.avoidPointsMap || ''}
              label="Video of the points to avoid on the map"
              onChange={event => {
                const newConfig = {
                  ...createRouteConfiguration,
                  avoidPointsMap: event.target.value
                };
                handleRouteConfiguration(newConfig);
              }}
              size="small"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {videoList.map(item => (
                <MenuItem key={item.name} value={item._id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box display="column" width="40%" gab={1}>
          <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={5}>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel id="demo-simple-select-label">Video of final points</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={videoSelect}
                    label="Video of final points"
                    onChange={event => {
                      setVideoSelect(event.target.value);
                    }}
                    size="small"
                  >
                    {videoList.map(item => (
                      <MenuItem key={item.name} value={item._id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="outlined-required"
                  label="Name to show"
                  size="small"
                  value={name}
                  onChange={event => setName(event.target.value)}
                  fullWidth
                />
                <IconButton
                  onClick={() => setOpenModalFinalButton(true)}
                  style={{
                    color: '#2A3F90'
                  }}
                >
                  {!isEmpty(buttonSelect.libraryIcon) ? (
                    <>
                      {buttonSelect.libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                        <FontAwesomeIcon icon={buttonSelect.iconFontawesome} />
                      )}
                      {buttonSelect.libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                        <img
                          src={buttonSelect.iconSvg}
                          alt={buttonSelect.iconFontawesome}
                          style={{ marginRight: '5px', width: '20px', height: '20px' }}
                        />
                      )}
                    </>
                  ) : (
                    <ShareIcon />
                  )}
                </IconButton>
                <ShowListIconsFontawesome
                  openModal={openModalFinalButton}
                  setOpenModal={setOpenModalFinalButton}
                  handleIconSelected={handleIconSelect}
                  selectedIcon={buttonSelect.iconFontawesome}
                  startLibrary={buttonSelect.libraryIcon}
                  svg={buttonSelect.iconSvg}
                  startCategorySvg={buttonSelect.cetegorySvg}
                />
              </Grid>
            </Grid>
          </Box>

          <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
            <Checkbox
              checked={createRouteConfiguration.centerOnRoute}
              onChange={() => {
                const newConfig = {
                  ...createRouteConfiguration,
                  centerOnRoute: !createRouteConfiguration.centerOnRoute
                };
                handleRouteConfiguration(newConfig);
              }}
              sx={{
                color: '#2A3F90',
                '&.Mui-checked': {
                  color: '#2A3F90'
                }
              }}
              value="variable"
            />
            Center on route
          </Box>
          <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
            <Checkbox
              checked={createRouteConfiguration.showMode}
              onChange={() => {
                const newConfig = {
                  ...createRouteConfiguration,
                  showMode: !createRouteConfiguration.showMode
                };
                handleRouteConfiguration(newConfig);
              }}
              sx={{
                color: '#2A3F90',
                '&.Mui-checked': {
                  color: '#2A3F90'
                }
              }}
              value="variable"
            />
            show how to do the route
          </Box>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="demo-simple-select-label">Mode</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={createRouteConfiguration.mode}
              label="Mode"
              onChange={event => {
                const newConfig = {
                  ...createRouteConfiguration,
                  mode: event.target.value
                };
                handleRouteConfiguration(newConfig);
              }}
              size="small"
            >
              {ModeRouteOptions.map(item => (
                <MenuItem key={item.value} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {!isEmpty(createRouteConfiguration.endPoints) && (
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="demo-simple-select-label">End point default</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={createRouteConfiguration.endPointDefault}
                label="End point default"
                onChange={event => {
                  const newConfig = {
                    ...createRouteConfiguration,
                    endPointDefault: event.target.value
                  };
                  handleRouteConfiguration(newConfig);
                }}
                size="small"
              >
                {createRouteConfiguration.endPoints.map(item => (
                  <MenuItem key={item.videoId} value={item.videoId}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <Button variant="contained" color="success" onClick={handleAddFinalPoints}>
            Add
          </Button>
          {createRouteConfiguration.endPoints && !isEmpty(createRouteConfiguration.endPoints) && (
            <>
              <Table>
                <TableBody>
                  {createRouteConfiguration.endPoints
                    .slice(startIndex, endIndex)
                    .map((item, index) => (
                      <TableRow key={uuid()}>
                        <TableCell>{item.name}</TableCell>
                        {/* <TableCell>{item.password}</TableCell> */}
                        <TableCell>
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteUser(startIndex + index)}
                            sx={{
                              color: '#2A3F90'
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  marginTop: '20px',
                  justifyContent: 'center'
                }}
              >
                <Pagination
                  count={Math.ceil(createRouteConfiguration.endPoints.length / itemsPerPage)}
                  page={page}
                  onChange={handleChangePage}
                  sx={{
                    '& .MuiPaginationItem-page.Mui-selected': {
                      backgroundColor: '#2A3F90',
                      color: 'white'
                    },
                    '& .MuiPaginationItem-page.Mui-selected .MuiPaginationItem-pageNumber': {
                      color: 'white'
                    }
                  }}
                />
              </Stack>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
        <Checkbox
          checked={createRouteConfiguration.show}
          onChange={() => {
            const newConfig = {
              ...createRouteConfiguration,
              show: !createRouteConfiguration.show
            };
            handleRouteConfiguration(newConfig);
          }}
          sx={{
            color: '#2A3F90',
            '&.Mui-checked': {
              color: '#2A3F90'
            }
          }}
          value="variable"
        />
        Create Route
        {createRouteConfiguration.show === true && (
          <Button
            variant="outlined"
            style={{ color: '#2A3F90' }}
            onClick={() => setOpenModal(true)}
          >
            <SettingsIcon style={{ color: '#2A3F90' }} />
          </Button>
        )}
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          style={{
            position: 'absolute',
            bgcolor: 'white',
            top: '2.5vh',
            left: '2.5vw'
          }}
        >
          {body}
        </Modal>
      </Box>
    </>
  );
};
export default RouteConfiguration;

RouteConfiguration.defaultProps = {};
RouteConfiguration.propTypes = {
  createRouteConfiguration: PropTypes.object.isRequired,
  videoList: PropTypes.array.isRequired,
  handleRouteConfiguration: PropTypes.func.isRequired
};
